import { combineReducers, AnyAction } from 'redux';
import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';

import { RELOAD } from 'src/store/actions/actionTypes';

import { reducer as alerts } from 'src/components/alert/slice';
import { reducer as application } from 'src/slice';
import pages from 'src/pages/reducer';
import { reducer as scenes } from 'src/components/scenes/slice';
import { reducer as skus } from 'src/components/skus/slice';
import { reducer as sceneConfiguration } from 'src/pages/editor/components/SceneVariation/slice';

const reducers = {
    application,
    alerts,
    pages,
    scenes,
    skus,
    sceneConfiguration,
};

// A guide on how reducers work http://redux.js.org/docs/basics/Reducers.html
const appReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history) as (state: RouterState | undefined, action: AnyAction) => RouterState,
        ...reducers,
    });

// TODO we should remove this silly reload wrapper at some point
export default function rootReducer(history: History) {
    // Can be used to both load a scene and to completely reset.
    // Should preserve cross-page data.
    return (state: ReturnType<ReturnType<typeof appReducer>> | undefined, action: AnyAction) => {
        let newState = state;
        if (action.type === RELOAD) {
            newState = Object.assign(action.payload, {
                scenes: state?.scenes,
                application: state?.application,
                alerts: state?.alerts,
                sceneConfiguration: state?.sceneConfiguration,
            });
        }
        return appReducer(history)(newState, action);
    };
}
